import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { Box } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <img width="960" role="presentation" src="https://user-images.githubusercontent.com/2313998/228976777-6239662c-0926-4e13-be0d-be1a1eff08ed.png" />
    <h2>{`Usage`}</h2>
    <p>{`A tab nav lets users navigate between related views in the same context. Each "tab" links to a different view that is shown when a user selects a tab.`}</p>
    <p>{`A tab nav is always a set of links, and each tab should have a unique URL. If you just want tabs that toggle between different views without changing the URL, use `}<a parentName="p" {...{
        "href": "/components/tab-panels"
      }}>{`tab panels`}</a>{`.`}</p>
    <h3>{`Best practices`}</h3>
    <ul>
      <li parentName="ul">{`One of the tabs should be selected by default when the user loads the page.`}</li>
      <li parentName="ul">{`Keep tab labels as short as possible - ideally no more than three words.`}</li>
      <li parentName="ul">{`Avoid overwhelming the user with too many tabs. Instead consider a navigation structure like a `}<a parentName="li" {...{
          "href": "/components/nav-list"
        }}>{`nav list`}</a>{` that's meant to handle more links.`}</li>
      <li parentName="ul">{`If a user navigates to a different tab panel, form data should not be automatically saved or submitted. Changes must be explicitly be saved or submitted.`}</li>
      <li parentName="ul">{`Avoid nesting a tab nav within another tab nav view's content.`}</li>
      <li parentName="ul">{`Don't force users to switch between multiple tabs to compare info. Each tab panel should have all of the information a user needs to complete their task.`}</li>
      <li parentName="ul">{`Don't nest buttons or links in the tab title. The tab is already a link or button, so it cannot have a child element that is also a link or button.`}</li>
    </ul>
    {/* TODO: Insert guidance about when to use UnderlineNav instead of TabNav */}
    {/* TODO: Add info about unread/unsaved tab status once we create the guidelines propsed in https://github.com/github/primer/issues/1886 */}
    <h2>{`Anatomy`}</h2>
    <img width="960" role="presentation" src="https://user-images.githubusercontent.com/2313998/231862815-e28a4a38-dfc9-4b7f-ad12-2a312619fcea.png" />
    <p><strong parentName="p">{`Links:`}</strong>{` A set of links used to switch between views. Each tab should concisely label the view it's associated with.`}</p>
    <p><strong parentName="p">{`View:`}</strong>{` The view associated with the active tab.`}</p>
    <h2>{`Options`}</h2>
    <img width="960" role="presentation" src="https://user-images.githubusercontent.com/2313998/229872878-1ad42b2f-28ea-43ff-b09f-02f2edf6b536.png" />
    <h3>{`With related content after the tabs`}</h3>
    <p>{`Content or an action may be shown after the tabs as long as it's something that's relevant to the content in all of the tab panels. For example, a diff is shown after the tabs on a pull request.`}</p>
    <p>{`However, the related content's element(s) should be a sibling of the element that wraps the tabs, not a child.`}</p>
    <h3>{`Tabs with counts`}</h3>
    <p>{`A `}<a parentName="p" {...{
        "href": "/components/counter-label"
      }}>{`counter label`}</a>{` may be used to show a count after the text label if the tab contains enumerable content that would be helpful for users to know without activating the tab.`}</p>
    <h3>{`Tabs with icons`}</h3>
    <p>{`An icon may be shown before the tab's text label to help users understand the purpose of the tab. For example, the number of files changed on a pull request's "Files changed" tab.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Each tab must have a unique text label for assistive technologies like screen readers. Avoid using tabs that only use an icon as their label. If an icon makes the tab easier to understand, consider pairing the icon with a text label.`}</p>
    <p>{`Tabs may not overflow their container - they must be clickable without requiring the user to horizontally scroll. This is a violation of the `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/WCAG21/Understanding/reflow.html"
      }}>{`WCAG reflow criteria`}</a>{`.`}</p>
    <h3>{`Labeling counts`}</h3>
    <p>{`If your tab shows a count of items, screen readers will read the number immediately after the tab's label. Consider whether it would sound awkward to the user, and add visually hidden text to help make it easier to understand what the number is for.`}</p>
    <p>{`For example, "Conversation 10" is confusing because there's no context for what the "10" is referring to. Instead, we can write our markup so screen readers will say "Conversation 10 comments".`}</p>
    <p>{`If we assume that the `}<inlineCode parentName="p">{`sr-only`}</inlineCode>{` class is used to only hide the element visually, that might look something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<span>
  Commits
  <div class="badge">4<span class="sr-only">&nbsp;comments</span>
</span>
`}</code></pre>
    <h3>{`Keyboard navigation`}</h3>
    <p>{`Each link in the tab nav should be a single Tab stop. The arrow keys should not move focus between tabs or activate tabs.`}</p>
    <h2>{`Related links`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/nav-list"
        }}>{`Nav list`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/tab-panels"
        }}>{`Tab panels`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/underline-nav"
        }}>{`Underline nav`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      